export const API_SERVER = process.env.REACT_APP_PUBLIC_API_SERVER;
